<template>
  <v-row id="pointsStore" no-gutters class="ml-md-12 my-6">
    <PointsPurchase />
  </v-row>
</template>

<script>
  import PointsPurchase from "./Purchase/PointsPurchase";

  export default {
    name: "PointsStore",

    components: {
      PointsPurchase,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Points/PointsStore.vue